/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Office } from '../../models/office';

export interface GetAllOffices$Plain$Params {
}

export function getAllOffices$Plain(http: HttpClient, rootUrl: string, params?: GetAllOffices$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Office>>> {
  const rb = new RequestBuilder(rootUrl, getAllOffices$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Office>>;
    })
  );
}

getAllOffices$Plain.PATH = '/api/Office';
